module.exports = __webpack_public_path__ + "static/high-fidelity-256b5a939965b92bede90b402d1e4176.jpg";